import { render } from "./TaskItemsList.vue?vue&type=template&id=63011263"
import script from "./TaskItemsList.vue?vue&type=script&lang=js"
export * from "./TaskItemsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__